import { render } from "./eventOverview.vue?vue&type=template&id=f975a84a&scoped=true"
import script from "./eventOverview.vue?vue&type=script&lang=js"
export * from "./eventOverview.vue?vue&type=script&lang=js"

import "./eventOverview.vue?vue&type=style&index=0&id=f975a84a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f975a84a"]])

export default __exports__